import { BFLType, ModuleTypeId } from "../../types/DBTables";
import { IGlobalData } from "../../types/globalData";
import { IBIMHandler } from "./bimHandler";
import { IModuleRound, IRoundHandler } from "../roundHandler";
//import { IModuleVattenburetSekundärsystem } from "../../types/ModuleDatas";

import bflHelper from "./bflHelper";
import { IBFModule, IBFResult, IKontrollResultRow, IKontrollResultRowDriftoptimering } from "../../types/BFL/Funktionskontroll";
import { IModuleByggnadsdata, IModuleVentilationFTXochFT } from "../../types/ModuleDatas";
import { VeckoSchemaPerioder } from "../../types/module-type";
import { sumSchedule } from "../TimePeriods";

//todo -> make class?!
export const bfl_J4_FTX = (): IBFModule => {
  const bfName = BFLType.BFL_J4_FTX;

  const getResult = (module: IModuleRound, bimHandler: IBIMHandler, roundHandler: IRoundHandler, globalData: IGlobalData): IBFResult => {
    //const moduleData: IModuleVattenburetSekundärsystem = module.data;

    let funktionsKontroller: IKontrollResultRow[] = [];
    let driftOptimeringar: IKontrollResultRowDriftoptimering[] = [];
    const debug = {} as any;

    const bH = bflHelper.bflHelper();

    try {
      const byggnadsModule = roundHandler.getRoundData()?.data.modules.find((m) => m.moduleTypeId === ModuleTypeId.Byggnadsdata);
      const byggnadModuleData = byggnadsModule?.data as IModuleByggnadsdata;
      const moduleData = module.data as IModuleVentilationFTXochFT;
      const isFTX = module.moduleTypeId === ModuleTypeId.VentilationFTX;

      const BIM_DensitetLuft = globalData.System.mapSystemParametrar.BIM_DensitetLuft;
      const BIM_Luft_Energimängd = globalData.System.mapSystemParametrar.BIM_Luft_Energimängd;
      const BIM_GradtimmarVärmeFörOrten = bimHandler.BIM_GradtimmarVärmeFörOrten;
      const BIM_NormalårsTemperatur = bimHandler.normalårsTemperatur;
      const BIM_TimmarPerGrad_Värme = bimHandler.BIM_TimmarPerGrad_Värme;
      const BIM_Vägledande_VerkninsgradAktuellVärmekälla = bimHandler.BIM_Vägledande_VerkninsgradAktuellVärmekälla;

      const ftxJ4TemperaturUteluft = moduleData.tempUteluft;
      const ftxJ4TemperaturTilluft = moduleData.tempTillLuftEfterÅtervinningsBat;
      const ftxJ4TemperaturFrånluft = moduleData.tempFrånLuftInnanÅtervinningsBat;
      const ftxJ4KontrollmätTemperatur = moduleData.ärvärdeRegTilluft;
      const ftxJ4UppmättTemperaturverkningsgrad =
        ftxJ4TemperaturFrånluft - ftxJ4TemperaturUteluft === 0 ? 0 : (ftxJ4TemperaturTilluft - ftxJ4TemperaturUteluft) / (ftxJ4TemperaturFrånluft - ftxJ4TemperaturUteluft);
      const ftxJ4FörväntadTemperaturverkningsgradRow = globalData.Ventilation.SystemtypÅtervinning.find((r) => r.SystemtypÅtervinning === moduleData.systemtypÅtervinningFTX);
      const ftxJ4FörväntadTemperaturverkningsgrad = ftxJ4FörväntadTemperaturverkningsgradRow ? ftxJ4FörväntadTemperaturverkningsgradRow.FörväntadTemperaturverkningsgrad : 0;

      let ftxJ4FlödeTilluftHelfart = moduleData.flödeTilluft;
      let ftxJ4FlödeFrånluftHelfart = moduleData.flödeFrånluft;
      if (moduleData.flödeEnhet === "Kubikmeter per timme (m³/h)") {
        ftxJ4FlödeTilluftHelfart = ftxJ4FlödeTilluftHelfart / 3.6;
        ftxJ4FlödeFrånluftHelfart = ftxJ4FlödeFrånluftHelfart / 3.6;
      }

      if (moduleData.flödeUppgift === "Uppgift saknas") {
        if (moduleData.flödesKanalForm === "Cirkulära") {
          const schablonCirkRow = globalData.Ventilation.KanalstorlekCirkulära.find((r) => r.KanalstorlekCirkulära === Number(moduleData.flödeFrånluftDiameter));
          ftxJ4FlödeTilluftHelfart = schablonCirkRow ? schablonCirkRow.LiterPerSekund : 0;
        } else {
          const schablonCirkRekt = globalData.Ventilation.KanalstorlekRektangulära.find((r) => r.KanalstorlekRektangulära === moduleData.flödeKanalstorlekBxH);
          ftxJ4FlödeTilluftHelfart = schablonCirkRekt ? schablonCirkRekt.LiterPerSekund : 0;
        }

        ftxJ4FlödeFrånluftHelfart = ftxJ4FlödeTilluftHelfart;
      }

      const driftÅretRunt = moduleData.driftÅretRunt === "Ja";
      const delfartsFaktor = moduleData.delfartsFaktor ? moduleData.delfartsFaktor / 100 : 0;

      const timmarHelår = 24 * 365;
      const timmarVecka = 24 * 7;
      const veckorPerÅr = timmarHelår / timmarVecka;

      let minuterHelfart = 0;
      let minuterDelfart = 0;
      if (driftÅretRunt) {
        const minuterPerVecka = (timmarHelår * 60) / veckorPerÅr; //8760 timmar * 60 minuter / veckor per år
        minuterHelfart = minuterPerVecka * (1 - delfartsFaktor);
        minuterDelfart = minuterPerVecka * delfartsFaktor;
      } else {
        minuterDelfart = moduleData.tidsKanaler ? sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Delfart") : 0;
        minuterHelfart = moduleData.tidsKanaler ? sumSchedule(moduleData.tidsKanaler.ventilation as VeckoSchemaPerioder, "Helfart") : 0;
      }
      const ftxJ4GårVentilationsaggregatReduceradDrift = minuterDelfart > 0 ? "Ja" : "Nej";
      const reduceratFlödeRumsdonFasta =
        moduleData.harReduceradeLuftflödeFastaRumsdon === "Ja" && moduleData.reduceratFlödeRumsdonFasta ? moduleData.reduceratFlödeRumsdonFasta : 0;
      const reduceratFlödeRumsdonReglerbara =
        moduleData.harReduceradeLuftflödeReglerbaraRumsdon === "Ja" && moduleData.reduceratFlödeRumsdonReglerbara ? moduleData.reduceratFlödeRumsdonReglerbara : 0;

      const ftxJ4FlödeTilluftReducerad = ftxJ4GårVentilationsaggregatReduceradDrift === "Ja" ? Math.max(reduceratFlödeRumsdonFasta, reduceratFlödeRumsdonReglerbara) : 0;

      const ftxJ4DrifttidHelfartH = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterHelfart) / 60;

      const ftxJ4DrifttidHelfartFaktor = ftxJ4DrifttidHelfartH >= 8760 ? 1 : ftxJ4DrifttidHelfartH / 8760;

      const ftxJ4DrifttidDelfartH = ((veckorPerÅr - moduleData.antalVeckorVentilationStoppadPerÅr) * minuterDelfart) / 60;

      const ftxJ4DrifttidDelfartFaktor = ftxJ4DrifttidDelfartH >= 8760 ? 1 : ftxJ4DrifttidDelfartH / 8760;

      const ftxJ4NormalEnergianvändningVärme =
        (ftxJ4FlödeTilluftHelfart / 1000) *
          BIM_DensitetLuft *
          BIM_Luft_Energimängd *
          BIM_GradtimmarVärmeFörOrten *
          (1 - ftxJ4FörväntadTemperaturverkningsgrad) *
          ftxJ4DrifttidHelfartFaktor +
        (ftxJ4FlödeTilluftHelfart / 1000) *
          ftxJ4FlödeTilluftReducerad *
          BIM_DensitetLuft *
          BIM_Luft_Energimängd *
          BIM_GradtimmarVärmeFörOrten *
          (1 - ftxJ4FörväntadTemperaturverkningsgrad) *
          ftxJ4DrifttidDelfartFaktor;

      const ftxJ4GradtimmarVärmeFörOrt = (moduleData.kontrollmättTempRegTilluft - BIM_NormalårsTemperatur) * BIM_TimmarPerGrad_Värme;

      const energikällaRow = globalData.Byggnadsdata.Värmekälla.find((r) => r.Värmekälla === byggnadModuleData.energikälla);
      const energiSlag = energikällaRow ? energikällaRow.Energislag : "?";

      debug["Grunddata (Tabell 1)"] = {
        "1. Benämning på ventilationssystem": module.name,
        "2. Systemtyp för ventilationssystem": isFTX ? "FTX" : "FT",
        "3. Systemtyp för återvinning": moduleData.systemtypÅtervinningFTX,
        "4. Temperatur uteluft (°C)": ftxJ4TemperaturUteluft,
        "5. Temperatur tilluft, mätpunkt direkt efter återvinningsbatteri (°C)": ftxJ4TemperaturTilluft,
        "6. Temperatur frånluft, mätpunkt direkt innan återvinningsbatteri  (°C)": ftxJ4TemperaturFrånluft,
        "7. Kontrollmät temperatur vid mätpunkt för regulator tilluft (°C)": ftxJ4KontrollmätTemperatur,
        "8. Uppmätt temperaturverknigsgrad för ventilationsaggregatets återvinning.": ftxJ4UppmättTemperaturverkningsgrad,
        "9. Förväntad temperaturverknigsgrad för denna formen av återvinningssystem.": ftxJ4FörväntadTemperaturverkningsgrad,
        "10. Flöde tilluft helfart (l/s)": ftxJ4FlödeTilluftHelfart,
        "11. Flöde frånluft helfart (l/s)": ftxJ4FlödeFrånluftHelfart,
        "12. Går ventialtionsaggregat på reducerad drift under någon tidsperiod (Ja/Nej)": ftxJ4GårVentilationsaggregatReduceradDrift,
        "13. Flöde tilluft reducerad drift (%)": ftxJ4FlödeTilluftReducerad,
        "14. Drifttid helfart i h  (X timmar/år) med befintlig tidkanal.": ftxJ4DrifttidHelfartH,
        "15. Driftfaktor i %  (X timmar av 8760) med helfart tidkanal.": ftxJ4DrifttidHelfartFaktor,
        "16. Drifttid delfart i h  (X timmar/år) med befintlig tidkanal.": ftxJ4DrifttidDelfartH,
        "17. Driftfaktor i %  (X timmar av 8760) med delfart tidkanal.": ftxJ4DrifttidDelfartFaktor,
        "18. Normal energianvändning värme (kWh/år). För beräkning besparings potential": ftxJ4NormalEnergianvändningVärme,
        "19. Gradtimmar värme för orten och aktuell °C tilluft  (Ch)": ftxJ4GradtimmarVärmeFörOrt,
        "20. System som betjänar eftervärmningsbatteri.": moduleData.eftervärmningsbatteri,
        "21. Energikälla för uppvärmning": byggnadModuleData.energikälla,
        "22. Vägledande verkningsgrad för värmekälla ": BIM_Vägledande_VerkninsgradAktuellVärmekälla,
        energiSlag,
      };

      const ftxJ4GränsAvvikelse = 0.05;
      const ftxJ4Obalans = ftxJ4FlödeTilluftHelfart > ftxJ4FlödeFrånluftHelfart ? (ftxJ4FlödeTilluftHelfart - ftxJ4FlödeFrånluftHelfart) / ftxJ4FlödeTilluftHelfart : 0;

      const ftxJ4NormTN = ftxJ4FörväntadTemperaturverkningsgrad;
      const ftxJ4UppmättTn = ftxJ4UppmättTemperaturverkningsgrad;
      const ftxJ4AvvikelseNormUppmätt = ftxJ4NormTN - ftxJ4UppmättTn;
      const ftxJ4AvvikelseTNObalans = ftxJ4Obalans * 0.0044 * 100;
      const ftxJ4AvvikelseTNAnnanBrist = ftxJ4AvvikelseNormUppmätt - ftxJ4AvvikelseTNObalans;

      debug["Avvikelse beräkning"] = {
        "Gräns avvikelse (%enheter)": ftxJ4GränsAvvikelse,
        Obalans: ftxJ4Obalans,
        "Norm tn": ftxJ4NormTN,
        "Uppmätt tn": ftxJ4UppmättTn,
        "Avvikelse Norm - Uppmätt tn": ftxJ4AvvikelseNormUppmätt,
        "Avvikelse tn sfa obalans": ftxJ4AvvikelseTNObalans,
        "Avvikelse tn sfa annan brist": ftxJ4AvvikelseTNAnnanBrist,
      };

      const ftxJ4AvvikelseTNVerkningsgrad = ftxJ4AvvikelseNormUppmätt > ftxJ4GränsAvvikelse ? ftxJ4AvvikelseNormUppmätt : 0; //=IF(ftxJ4AvvikelseNormUppmätt>ftxJ4GränsAvvikelse;ftxJ4AvvikelseNormUppmätt;0)
      const ftxJ4AvvikelseTNKilowattsPerYear =
        (ftxJ4FlödeTilluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * ftxJ4GradtimmarVärmeFörOrt * ftxJ4AvvikelseTNVerkningsgrad * ftxJ4DrifttidHelfartFaktor +
        (ftxJ4FlödeTilluftHelfart / 1000) *
          ftxJ4FlödeTilluftReducerad *
          BIM_DensitetLuft *
          BIM_Luft_Energimängd *
          ftxJ4GradtimmarVärmeFörOrt *
          ftxJ4AvvikelseTNVerkningsgrad *
          ftxJ4DrifttidDelfartFaktor;

      debug["Avvikelse tn (temperaturverkningsgrad)"] = {
        "Temperaturverkningsgrad ÅV": ftxJ4AvvikelseTNVerkningsgrad,
        "kWh/år netto": ftxJ4AvvikelseTNKilowattsPerYear,
      };

      const ftxJ4AvvikelseAnnanBristVerkningsgrad = ftxJ4AvvikelseTNAnnanBrist > ftxJ4GränsAvvikelse ? ftxJ4AvvikelseTNAnnanBrist : 0;
      const ftxJ4AvvikelseAnnanBristKilowattsPerYear =
        (ftxJ4FlödeTilluftHelfart / 1000) *
          BIM_DensitetLuft *
          BIM_Luft_Energimängd *
          ftxJ4GradtimmarVärmeFörOrt *
          ftxJ4AvvikelseAnnanBristVerkningsgrad *
          ftxJ4DrifttidHelfartFaktor +
        (ftxJ4FlödeTilluftHelfart / 1000) *
          ftxJ4FlödeTilluftReducerad *
          BIM_DensitetLuft *
          BIM_Luft_Energimängd *
          ftxJ4GradtimmarVärmeFörOrt *
          ftxJ4AvvikelseAnnanBristVerkningsgrad *
          ftxJ4DrifttidDelfartFaktor;

      debug["Avvikelse tn sfa annan brist än obalans"] = {
        "Temperaturverkningsgrad ÅV": ftxJ4AvvikelseAnnanBristVerkningsgrad,
        "kWh/år netto": ftxJ4AvvikelseAnnanBristKilowattsPerYear,
      };

      // *********Avvikelse tn sfa obalans
      const ftxJ4AvvikelseBalansVerkningsgrad = ftxJ4AvvikelseTNObalans > ftxJ4GränsAvvikelse && ftxJ4AvvikelseNormUppmätt > ftxJ4GränsAvvikelse ? ftxJ4AvvikelseTNObalans : 0; // =IF(AND(ftxJ4AvvikelseTNObalans>ftxJ4GränsAvvikelse;ftxJ4AvvikelseNormUppmätt>ftxJ4GränsAvvikelse);ftxJ4AvvikelseTNObalans;0)
      const ftxJ4AvvikelseBalansKilowattsPerYear =
        (ftxJ4FlödeTilluftHelfart / 1000) * BIM_DensitetLuft * BIM_Luft_Energimängd * ftxJ4GradtimmarVärmeFörOrt * ftxJ4AvvikelseBalansVerkningsgrad * ftxJ4DrifttidHelfartFaktor +
        (ftxJ4FlödeTilluftHelfart / 1000) *
          ftxJ4FlödeTilluftReducerad *
          BIM_DensitetLuft *
          BIM_Luft_Energimängd *
          ftxJ4GradtimmarVärmeFörOrt *
          ftxJ4AvvikelseBalansVerkningsgrad *
          ftxJ4DrifttidDelfartFaktor;

      debug["Avvikelse tn sfa obalans"] = {
        "Temperaturverkningsgrad ÅV": ftxJ4AvvikelseBalansVerkningsgrad,
        "kWh/år netto": ftxJ4AvvikelseBalansKilowattsPerYear,
      };

      const utstyrningVärmeåtervinningGTE099 = moduleData.utstyrningVärmeåtervinning >= 99;
      const flödeÄrUppmätt = ["Fast flödesmätare", "Egen mätning", "Uppmätt OVK"].find((v) => v === moduleData.flödeUppgift);
      const ingenSeparatFFVentilation = moduleData.harSeparatFrånluftsfläkt === "Nej"; //IF(harSeparatFrånluftsfläkt="Nej";1;0)

      const ftxJ4VillkorMedd1 = flödeÄrUppmätt && ingenSeparatFFVentilation && isFTX && utstyrningVärmeåtervinningGTE099 && ftxJ4AvvikelseBalansKilowattsPerYear > 0; //=IF(AND(H41=1;H38=1;H39=1;H40=1;H42=1);1;0)const ftxJ4VillkorMedd1 = flödeÄrUppmätt && ingenSeparatFFVentilation && isFTX && utstyrningVärmeåtervinningGTE099 && ftxJ4AvvikelseBalansKilowattsPerYear > 0;//=IF(AND(H41=1;H38=1;H39=1;H40=1;H42=1);1;0)
      const ftxJ4VillkorMedd2 = flödeÄrUppmätt && ingenSeparatFFVentilation && isFTX && utstyrningVärmeåtervinningGTE099 && ftxJ4AvvikelseAnnanBristKilowattsPerYear > 0; //=IF(AND(H41=1;H38=1;H39=1;H40=1;H42=1);1;0)
      const ftxJ4VillkorMedd3 = !flödeÄrUppmätt && ingenSeparatFFVentilation && isFTX && utstyrningVärmeåtervinningGTE099 && ftxJ4AvvikelseTNKilowattsPerYear > 0; //=IF(AND(H41=1;H38=1;H39=1;H40=1;H42=1);1;0)

      debug["Villkor"] = {
        utstyrningVärmeåtervinningGTE099,
        flödeÄrUppmätt,
        ingenSeparatFFVentilation,
        ftxJ4VillkorMedd1,
        ftxJ4VillkorMedd2,
        ftxJ4VillkorMedd3,
      };

      if (ftxJ4VillkorMedd1) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 1, ftxJ4AvvikelseBalansKilowattsPerYear, energiSlag));
      // funktionsKontroller.push({
      //   index: 1,
      //   kWhs: ftxJ4AvvikelseBalansKilowattsPerYear,
      //   energiSlag: energiSlag,
      //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFLJ4FTX_FKText1,
      // });

      if (ftxJ4VillkorMedd2) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 2, ftxJ4AvvikelseAnnanBristKilowattsPerYear, energiSlag));
      // funktionsKontroller.push({
      //   index: 2,
      //   kWhs: ftxJ4AvvikelseAnnanBristKilowattsPerYear,
      //   energiSlag: energiSlag,
      //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFLJ4FTX_FKText2,
      // });
      if (ftxJ4VillkorMedd3) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 3, ftxJ4AvvikelseTNKilowattsPerYear, energiSlag));
      // funktionsKontroller.push({
      //   index: 3,
      //   kWhs: ftxJ4AvvikelseTNKilowattsPerYear,
      //   energiSlag: energiSlag,
      //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFLJ4FTX_FKText3,
      // });

      const villkor4 = !ftxJ4VillkorMedd1 && !ftxJ4VillkorMedd2 && !ftxJ4VillkorMedd3 && utstyrningVärmeåtervinningGTE099; // =IF(AND(SUM(H22:H24)<1;H42+H54+H65>0);BFLJ4FTX_FKText4;"")
      if (villkor4) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 4, undefined, ""));
      // funktionsKontroller.push({
      //   index: 4,
      //   kWhs: undefined,
      //   energiSlag: "",
      //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFLJ4FTX_FKText4,
      // });

      if (!utstyrningVärmeåtervinningGTE099) funktionsKontroller.push(roundHandler.getFunktionsKontroll(bfName, 5, undefined, ""));
      // funktionsKontroller.push({
      //   index: 5,
      //   kWhs: undefined,
      //   energiSlag: "",
      //   message: globalData.Funktionskontroller.mapFunktionskontroller.BFLJ4FTX_FKText5,
      // });

      return {
        bfName: BFLType.BFL_J4_FTX,
        funktionsKontroller: bH.cleanFunktionsKontroller(funktionsKontroller),
        driftOptimeringar: bH.cleanDriftoptimeringar(driftOptimeringar),
        note: "",
        data: {
          //IJ4_FTX_FT_BFData
          export: {
            uppmättTemperaturverkningsgrad: ftxJ4UppmättTemperaturverkningsgrad,
            förväntadTemperaturverkningsgrad: ftxJ4FörväntadTemperaturverkningsgrad,
          },
        },
        debug,
      };
    } catch (err) {
      return {
        bfName: BFLType.BFL_J3_FTX_FT,
        funktionsKontroller: [],
        driftOptimeringar: [],
        note: "",
        data: {},
        debug: { Error: err },
        error: err,
      };
    }
  };

  return { getResult, bfName };
};

const dflt = { bfl_J4_FTX };

export default dflt;
